import { render, staticRenderFns } from "./ExamDetailsModal.vue?vue&type=template&id=126193a6"
import script from "./ExamDetailsModal.vue?vue&type=script&lang=js"
export * from "./ExamDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports